export default __webpack_public_path__ + "static/media/Run.4e551100.png";